import { useContext, useEffect, useState } from "react";
import RegistrarCuenta, {
  ConfirmarRegistroCuenta,
} from "../RegistrarCuenta/ConfirmarRegistroCuenta";

export const ConfirmarRegistro = () => {
  return (
    <>
      <ConfirmarRegistroCuenta />
    </>
  );
};
